module.exports = __webpack_public_path__ + "img/Divii-Logo-Primary.adb9eab4.svg";